// libraries
import type { AnyFSA } from '@makemydeal/dr-browser-utils';
import { ToggleStatsToggleItem, toggleUseRegistry } from '@makemydeal/dr-feature-toggles-client';
import {
    ReduxMiddleware,
    ReduxNext,
    ReduxStore,
    bootstrapActionTypes,
    toggleStatsActionCreators,
    toggleStatsActionTypes
} from '@makemydeal/dr-shared-store';
import { OPEN_DEAL_APP_PREFIX, isFeatureToggleStatsEnabled, setupFeatureToggleStats } from '@makemydeal/dr-shared-ui-utils';

// interfaces/types
import { OpenDealStateTree } from '../types/stateTreeTypes';
import { getServicesBff } from '../selectors/openDealAppSelectors';

export const toggleStatsMiddleware: ReduxMiddleware<OpenDealStateTree> =
    (store: ReduxStore<OpenDealStateTree>) => (next: ReduxNext) => async (action: AnyFSA) => {
        next(action);
        switch (action.type) {
            case bootstrapActionTypes.BOOTSTRAP_SUCCESS: {
                const state = store.getState();
                const configObject = getServicesBff(state);
                if (isFeatureToggleStatsEnabled(action.payload)) {
                    const updateToggleStatsApiCall = (toggleStatsItems: ToggleStatsToggleItem[]) => {
                        const updateToggleStatsAction = toggleStatsActionCreators.updateFeatureToggleStatsRequest(
                            OPEN_DEAL_APP_PREFIX,
                            toggleStatsItems,
                            configObject
                        );
                        store.dispatch(updateToggleStatsAction);
                    };
                    setupFeatureToggleStats(action.payload, updateToggleStatsApiCall);
                }
                break;
            }
            case toggleStatsActionTypes.UPDATE_FEATURE_TOGGLE_STATS_SUCCESS: {
                toggleUseRegistry.onApiCallSuccess();
                break;
            }
            case toggleStatsActionTypes.UPDATE_FEATURE_TOGGLE_STATS_FAILURE: {
                const message = action.payload.message;
                const response = action.payload.response;
                toggleUseRegistry.onApiCallFailure(message, response);
                break;
            }
        }
    };
